<template>
  <div class="base-info__container base-flex">
    <div class="base-info__left">
      <h3>{{ $t('multiCloudCluster.instanceDetails.detailsInfo.basicInfo') }}</h3>
      <div class="base-margin__bottom-20"><span>{{
          $t('multiCloudCluster.instanceDetails.detailsInfo.instanceName')
        }}</span><span>{{ instanceDetails.instanceName }}</span></div>
      <div class="base-margin__bottom-20"><span>{{
          $t('multiCloudCluster.instanceDetails.detailsInfo.instanceId')
        }}</span><span>{{ instanceDetails.instanceId }}</span></div>
      <div class="base-margin__bottom-20"><span>{{
          $t('multiCloudCluster.instanceDetails.detailsInfo.instanceType')
        }}</span><span>{{ instanceDetails.instanceType }}</span></div>
      <div class="base-margin__bottom-20"><span>{{ $t('multiCloudCluster.instanceDetails.detailsInfo.imageId') }}</span><span>{{
          instanceDetails.image
        }}</span></div>
      <div class="base-margin__bottom-20"><span>{{
          $t('multiCloudCluster.instanceDetails.detailsInfo.vpcId')
        }}</span><span>{{ instanceDetails.vpcId }}</span></div>
      <div class="base-margin__bottom-20"><span>{{
          $t('multiCloudCluster.instanceDetails.detailsInfo.chargeType')
        }}</span>
        <span>{{
            instanceDetails.chargeType === 'POSTPAID_BY_HOUR'
              ? $t('multiCloudCluster.instanceDetails.detailsInfo.payAsYouGo')
              : instanceDetails.chargeType === 'PREPAID'
                ? $t('multiCloudCluster.instanceDetails.detailsInfo.monthlyYearly')
                : $t('multiCloudCluster.instanceDetails.detailsInfo.spotInstance')
          }}</span>
      </div>
      <div class="base-margin__bottom-20"><span>{{
          $t('multiCloudCluster.instanceDetails.detailsInfo.region')
        }}</span><span>{{
          instanceDetails.Zone || '-'
        }}</span>
      </div>
      <div class="base-margin__bottom-20"><span>{{
          $t('multiCloudCluster.instanceDetails.detailsInfo.createTime')
        }}</span><span>{{
          processISO8601Time(instanceDetails.createAt)
        }}</span>
      </div>
      <div class="base-margin__bottom-20"><span>{{
          $t('multiCloudCluster.instanceDetails.detailsInfo.expireTime')
        }}</span><span>{{
          processISO8601Time(instanceDetails.expireAt)
        }}</span>
      </div>
      <div class="base-margin__bottom-20"><span>{{
          $t('multiCloudCluster.instanceDetails.detailsInfo.status')
        }}</span><span>{{
          instanceDetails.status
        }}</span>
      </div>
    </div>
    <div class="base-info__right">
      <h3>{{ $t('multiCloudCluster.instanceDetails.detailsInfo.networkInfo') }}</h3>
      <div class="base-margin__bottom-20">
        <span>{{
            $t('multiCloudCluster.instanceDetails.detailsInfo.elasticPublicIP')
          }}</span><span>{{ instanceDetails.publicIP || '-' }}</span>
      </div>
      <div class="base-margin__bottom-20">
        <span>{{
            $t('multiCloudCluster.instanceDetails.detailsInfo.privateIP')
          }}</span><span>{{ instanceDetails.privateIP || '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {processISO8601Time} from '@/common/utils/utils';


export default {
  name: 'baseInfo',
  components: {},
  props: {
    instanceDetails: Object,
  },
  data() {
    return {
      processISO8601Time,
    };
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.previewDialog_main--div {
  max-height: 400px;
}

.base-info__container {
  height: 100%;
  overflow: auto;
  background: #fff;
  padding: 10px 20px 30px;

  span:first-child {
    display: inline-block;
    width: 106px;
    margin-right: 20px;
  }
}

.base-info__left, .base-info__right {
  width: 50%;

  h3 {
    margin-bottom: 30px;
  }
}

.exportPreviewCls {
  padding: 12px 20px;
}
</style>
